/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_Layouttitle1Inputs */

const ja_calendar_meta_layouttitle1 = /** @type {(inputs: Calendar_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Calendar.`)
};

const en_calendar_meta_layouttitle1 = /** @type {(inputs: Calendar_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Calendar.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN Calendar." |
*
* @param {Calendar_Meta_Layouttitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const calendar_meta_layouttitle1 = /** @type {((inputs?: Calendar_Meta_Layouttitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_Layouttitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_layouttitle1(inputs)
	return en_calendar_meta_layouttitle1(inputs)
});
export { calendar_meta_layouttitle1 as "calendar_meta_layoutTitle" }